export function headerRender() { return `<div class="headerCont">
    <div class="header" style="${ this.__$objToStyleMap(this.style)  }">
        <div class="text"></div>
    </div>
</div>`  }